<template>
  <form
    class="mt-4"
    v-if="form"
    @submit.prevent="submit"
    @keydown="form.onKeydown($event)"
  >
    <div class="row bg-white pt-3">
      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="titre"
            >Titre échange <span class="text-danger">*</span></label
          >
          <input
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('titre'),
            }"
            id="titre"
            v-model="form.titre"
            type="text"
            placeholder="Numéro de l'échange"
            maxlength="50"
            required
          />
          <has-error :form="form" field="titre"></has-error>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="date"
            >Date echange <span class="text-danger">*</span></label
          >
          <date-picker
            v-model="form.date"
            name="date"
            placeholder="Date"
            lang="fr"
            format="DD/MM/YYYY"
            value-type="DD/MM/YYYY"
          ></date-picker>
          <input
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('date'),
            }"
            type="hidden"
          />
          <has-error :form="form" field="date"></has-error>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 mt-n1">
        <div class="form-group">
          <label for="type_echange"
            >Type echange <span class="text-danger">*</span></label
          >
          <v-custom-select
            label="nom"
            id="type_echange"
            :options="type_echanges"
            :reduce="(type_echange) => type_echange.uuid"
            v-model="form.type_echange"
            placeholder="type de echange"
          >
            <template v-slot:option="{ nom }">
              <h5 style="margin: 0">{{ nom }}</h5>
            </template>
            <template #no-options> Aucune données </template>
            <template #search="{ attributes, events }">
              <input
                class="custom-select-height vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-custom-select>
          <input
            type="hidden"
            class="form-control"
            :class="{
              'is-invalid': form.errors.has('type_echange'),
            }"
          />
          <has-error :form="form" field="type_echange"></has-error>
        </div>
      </div>
      <div class="col-12 mt-n1">
        <div class="w-100 mt-2">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="mr-1" :class="'mdi mdi-comment-edit'"></i>
                  Commentaire
                </h5>
              </div>
            </template>
            <div class="row editor p-0">
              <div class="col-md-12">
                <vue-editor
                  id="commentaire"
                  v-model="form.commentaire"
                  :editorToolbar="VueEditorToolbar"
                  class="fonction-mission"
                />
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <div class="col-12 mt-n1 mb-4">
      <div class="col-md-12 text-right">
        <button
          v-if="!edit"
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="list"
        >
          Liste des échanges
        </button>

        <ButtonLoader
          :busy="form.busy"
          type="submit"
          customClass="btn btn-custom-primary w-40"
          loadText="Traitement en cours..."
          :Text="`${edit ? 'Enregistrer' : 'Créer'}`"
          style="min-width: 100px"
        ></ButtonLoader>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    type_echanges: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: null,
      VueEditorToolbar,
    };
  },
  components: {
    DatePicker,
    VueEditor,
  },

  methods: {
    /**
     * Modal note
     */

    init() {
      this.form = this.propForm;
    },
    submit() {
      this.$emit('submit', this.form);
    },
    list() {
      this.$emit('echangeList');
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
